import { captureException } from '@sentry/react'
import axios from '@/axios-instance-node'
import { GetSubgeosSchema } from '@/features/subgeo/types.ts'
import { parseResponseData } from '@/helpers/utils'
import type { ResponseType } from '@/types.ts'

export interface HttpUpdateSubgeoParams {
	urlParams: {
		id: string
	}
	payload: {
		name?: string
		geoCode?: string
	}
	params: {
		responseType: ResponseType
	}
}

export const httpUpdateSubgeo = async ({
	urlParams,
	payload,
	params
}: HttpUpdateSubgeoParams) => {
	const response = await axios.put(
		`/v1/geo-mapping-sub-geos/${urlParams.id}`,
		payload,
		{ params }
	)

	return parseResponseData({
		responseData: response.data,
		responseShape: GetSubgeosSchema,
		onZodError: captureException
	})
}
